import { ICustomBinding } from '#/DefaultViewExtensionInterfaces';

export default class FlowLayoutItemBinding implements ICustomBinding {

    initBinding() {
        ko.bindingHandlers.flowLayoutItem = {
            init: (node: HTMLElement, valueAccessor: () => any) => {
                let element = $(node);
                let options = valueAccessor();
                let labelPosition = 'c-labelposition-' + options.tuple.factory.labelPosition.toLowerCase();

                $('<div class="c-caption ' + labelPosition + '">').append(options.tuple.label).appendTo(element);
                $('<div class="c-control">').append(options.tuple.control).appendTo(element);
            }
        };
    }
}